/* RINSE+ explainer video.
   Desktop gets the landscape cut, mobile gets the portrait cut.
   Autoplay, muted, looping, plays inline. A tap turns the sound on.
   Pauses itself when scrolled off screen. Draft theme. */
(function () {
  var SELECTOR = '.rp-hiw-video, .pdp-action-video, [data-rp-explainer]';

  /* Shopify's transcoded H.264 mp4 renditions. The raw uploads are QuickTime
     containers, which some browsers refuse, so these are the safe source. */
  var LANDSCAPE = 'https://cdn.shopify.com/videos/c/vp/fb1e84362faf4926a34cfeb012c149b4/fb1e84362faf4926a34cfeb012c149b4.SD-480p-1.5Mbps-92664573.mp4';
  var PORTRAIT = 'https://cdn.shopify.com/videos/c/vp/c6ca513a26464b09bf7c9dfae6b4a718/c6ca513a26464b09bf7c9dfae6b4a718.HD-720p-2.1Mbps-92664564.mp4';

  /* if a rendition ever fails, fall back to the raw upload */
  var FALLBACK = {};
  FALLBACK[LANDSCAPE] = 'https://cdn.shopify.com/videos/c/o/v/fb1e84362faf4926a34cfeb012c149b4.mp4';
  FALLBACK[PORTRAIT] = 'https://cdn.shopify.com/videos/c/o/v/c6ca513a26464b09bf7c9dfae6b4a718.mp4';

  var DESKTOP = '(min-width: 750px)';

  var ICON_OFF =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M11 5 6 9H2v6h4l5 4z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';

  var ICON_ON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function wantedSrc() {
    return isDesktop() ? LANDSCAPE : PORTRAIT;
  }

  function attemptPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Point the element at the right cut. The <source> tags in the theme stay as
     the no-JS fallback; once JS runs we drive src directly. */
  function applySrc(v) {
    var want = wantedSrc();
    if (v.dataset.rpSrc === want) return false;
    v.dataset.rpSrc = want;

    var srcs = v.querySelectorAll('source');
    for (var i = 0; i < srcs.length; i++) srcs[i].parentNode.removeChild(srcs[i]);

    var wasMuted = v.muted;
    v.setAttribute('src', want);
    v.load();
    v.muted = wasMuted;
    attemptPlay(v);
    return true;
  }

  function setup(v) {
    if (v.dataset.rpVideo) return;
    v.dataset.rpVideo = '1';

    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('preload', 'metadata');
    /* the theme posters are portrait stills; they letterbox badly in the
       desktop 4:3 frame, so drop them and let the carbon frame show instead */
    v.removeAttribute('poster');

    v.addEventListener('error', function () {
      var alt = FALLBACK[v.dataset.rpSrc];
      if (!alt || v.dataset.rpFellBack) return;
      v.dataset.rpFellBack = '1';
      v.setAttribute('src', alt);
      v.load();
      v.muted = true;
      attemptPlay(v);
    });

    applySrc(v);

    var wrap = v.parentElement;
    if (!wrap) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rp-sound-btn';

    var ico = document.createElement('span');
    ico.className = 'rp-sound-ico';
    var txt = document.createElement('span');
    txt.className = 'rp-sound-txt';
    btn.appendChild(ico);
    btn.appendChild(txt);

    function sync() {
      var on = !v.muted;
      btn.classList.toggle('is-on', on);
      ico.innerHTML = on ? ICON_ON : ICON_OFF;
      txt.textContent = on ? 'Sound on' : 'Tap for sound';
      btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function toggle(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      v.muted = !v.muted;
      if (!v.muted) attemptPlay(v);
      sync();
    }

    btn.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
    v.addEventListener('volumechange', sync);

    wrap.appendChild(btn);
    sync();

    /* stop it eating data when nobody is looking at it */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              attemptPlay(v);
            } else {
              v.pause();
              if (!v.muted) {
                v.muted = true;
                sync();
              }
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(v);
    }

    v.__rpSync = sync;
  }

  function init() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  /* swap the cut if the viewport crosses the breakpoint or the phone is turned */
  function onBreakpoint() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (!v.dataset.rpVideo) continue;
      if (applySrc(v) && v.__rpSync) v.__rpSync();
    }
  }

  var mq = window.matchMedia(DESKTOP);
  if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
  else if (mq.addListener) mq.addListener(onBreakpoint);
  window.addEventListener('orientationchange', onBreakpoint);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
